/**
 * Finds a product by its ID within a nested product structure.
 *
 * @param {Array} products - The array of products to search through. Each product is expected to be an object with the following structure:
 *   {
 *     productId: string,
 *     childProducts: Array (optional) - An array of child product objects with the same structure.
 *   }
 * @param {string} productId - The ID of the product to find.
 * @returns {Object|null} - The product object if found, otherwise null.
 */
export const findProductById = (products, productId) => {
    for (const product of products) {
        if (product.productId === productId) {
            return product;
        }
        if (product.childProducts && product.childProducts.length > 0) {
            const foundProduct = findProductById(product.childProducts, productId);
            if (foundProduct) {
                return foundProduct;
            }
        }
    }
    return null;
};